<template>
  <div class="py-0" align-self="center" @click="goback">
    <div class="back">
      <i class="pi pi-arrow-left"></i>
      <span v-if="backlist">{{ navName }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setupHistoryManagement } from "../../modules/Inventory/Service/HistoryManage";


export default defineComponent({
  props: {
    path: {
      type: String,
      required: false,
    },
    backlist: {
      type: Boolean,
      default: true,
    },
    navName: {
      type: String,
      default: "Back To Listing",
    },
    goback: {
      type: Function as PropType<(() => void) | undefined>,
      required: false,
    },
    flag: {
      type: Number,
      default: 2
    }
  },

  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const callHeader = ref(false);
    const goback = () => {
      debugger;
      if (props.goback) {
        setupHistoryManagement(router, props.flag);
        //props.goback()
      } else {
        router.push(props.path!);
      }
      emit("clickclear")
    };

    return {
      goback,
      // setupHistoryManagement
    };
  },
});
</script>

<style lang="scss">
@import "../../assets/variables.scss";

.back {
  color: $BackToMaster;
  font-size: 14px;
  cursor: pointer !important;
  display: flex;
  align-items: center;

  .pi-arrow-left {
    padding-right: 10px;
  }

  i {
    font-size: 11px;

  }
}
</style>
